"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function Form(_a) {
    var message = _a.message, setMessage = _a.setMessage;
    return react_1.default.createElement(storybook_1.Cards.Card, { className: 'storybook-pages-voucher-save-type' },
        react_1.default.createElement(storybook_1.Cards.Content, null,
            react_1.default.createElement(storybook_1.Forms.Field, null,
                react_1.default.createElement(storybook_1.Texts.Small, null, "Via onderstaand formulier stuur je direct een push bericht naar je volgers die zich hiervoor hebben aangemeld. Zij ontvangen dit bericht ook als ze op een andere website zitten. Zo bereik je je fans direct! Gebruik push notificaties bijvoorbeeld om je live wedstrijd of een nieuwe video aan te kondigen, maar doe dit met mate en voorkom spam.")),
            react_1.default.createElement(storybook_1.Forms.Label, null, "TITEL"),
            react_1.default.createElement(storybook_1.Forms.Field, null,
                react_1.default.createElement(storybook_1.Forms.Input, { name: 'title', value: message.title, placeholder: 'Titel', onChange: function (title) { return setMessage({ title: title }); } })),
            react_1.default.createElement(storybook_1.Forms.Label, null, "BERICHT"),
            react_1.default.createElement(storybook_1.Forms.Field, null,
                react_1.default.createElement(storybook_1.Forms.Textarea, { name: 'body', value: message.body, placeholder: 'Bericht', onChange: function (body) { return setMessage({ body: body }); } }))));
}
exports.default = Form;
